// import * as Hammer from 'hammerjs';
// import Modernizr from '../../../vendor/js/modernizr.js';

// var mc;

var openLayer = function() {
	$('body').addClass('overlay-open');
	$('html').css('overflow-y','hidden');

	// if(Modernizr.touchevents) {
	// 	mc = new Hammer($('.site')[0]);
	// 	mc.on("panright", function(ev) {
	// 		if(ev.angle > -45 && ev.angle < 45) {
	// 			closeLayer();
	// 		}
	// 	});
	// }
}

var closeLayer = function() {
	$('body').removeClass('overlay-open');
	$('html').css('overflow-y','scroll');
}

$('.js-open-overlay').on('click',function (e) {
	openLayer();
});

$('.js-close-overlay').on('click',function (e) {
	closeLayer();
});

$(document).keyup(function(e) {
	if (e.keyCode == 27) { closeLayer(); }
});
